import { loadCollectionItems } from '../pluginComponentApi';

export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, projectId, multiTenantPlugin, version, types, labels } = opts;
  const {
    setting: { tenantReferenceField, userSettingsField },
  } = multiTenantPlugin ? multiTenantPlugin : '';
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': labels.container,
          projectId: projectId,
          tenantReferenceField: tenantReferenceField,
          userSettingsField: userSettingsField,
          tagName: 'li',
          classes: ['nav-item', 'dropdown'],
          droppable: false, // Can't drop other elements inside
          traits: [].concat(defaultModel.prototype.defaults.traits),
          script: function () {},
        },
        init() {},
      },
      {
        isComponent(el) {
          console.log('Checking div issue: role-mapping-dropdown');
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView,
  });
  dc.addType(`${types.select}`, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label,
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          version: version,
          traits: [
            ...dc.getType('select').model.prototype.defaults.traits,
            ...dc.getType('default').model.prototype.defaults.traits,
          ],
          script: function () {
            let collectionId = '{[ collectionName ]}';
            console.log('🚀 ~ file: components.js:57 ~ collectionId:', collectionId);
            let collectionField = '{[ collectionField ]}';
            console.log('🚀 ~ file: components.js:59 ~ collectionField:', collectionField);
            const fieldName = '{[ fieldName ]}';
            console.log('🚀 ~ file: components.js:61 ~ fieldName:', fieldName);

            let formEl = this.closest('form');
            let isModal = false;
            const isModalForm = formEl && formEl.closest('[id^=modal-container]');
            isModal = isModalForm ? true : false;
            console.log('🚀 ~ file: components.js:67 ~ isModal:', isModal);
            if (isModal) {
              formEl.setAttribute('data-form-modal', true);
              this.setAttribute('data-collection-field', collectionField);
            }

            if (typeof loadTenantRoleMappingSelectOptions !== 'undefined') {
              console.log('*** Loading Tenant Role Mapping Dropdown...');
              loadTenantRoleMappingSelectOptions(this, isModal);
            }
          },
        },
        async init() {
          this.removeTrait('');
          const roleItems = await loadCollectionItems(projectId, version, 'role');
          console.log('🚀 ~ file: components.js:99 ~ init ~ roleItems:', roleItems);

          let options = [];
          if (!roleItems || roleItems.length === 0) {
            options = [{ label: '- Select Roles - ', value: '' }];
          } else {
            const roleOptions = roleItems.map((role) => ({
              label: role.name,
              value: `${role.value}`,
            }));
            options = [{ label: '- Select Roles - ', value: '' }, ...roleOptions];
          }
          console.log('🚀 ~ file: components.js:110 ~ init ~ options:', options);
          let collectionForm =
            this.closestType('collection-form') || this.closestType('sign-up-form');

          let userMultipleRolesForm = this.closestType('user-multiple-role-form');
          console.log(
            '🚀 ~ file: components.js:1056 ~ init ~ userMultipleRolesForm:',
            userMultipleRolesForm,
          );

          const collectionField = this.get('collectionField');
          console.log('🚀 ~ file: components.js:127 ~ init ~ collectionField:', collectionField);
          const fieldName = this.get('fieldName');
          console.log('🚀 ~ file: components.js:129 ~ init ~ fieldName:', fieldName);

          if (collectionForm) {
            const collectionName = collectionForm.getAttributes()['data-form-collection'];
            console.log('🚀 ~ file: components.js:133 ~ init ~ collectionName:', collectionName);
            if (collectionName) {
              const allTraits = this.get('traits');
              let traitsSize = allTraits.length;
              let attributes = this.getAttributes();

              const roleKeys = Object.keys(attributes).filter((attr) =>
                attr.startsWith('data-role-'),
              );
              console.log('🚀 ~ file: components.js:140 ~ init ~ roleKeys:', roleKeys);

              if (roleKeys && roleKeys.length > 0) {
                roleKeys.map((perName, index) => {
                  this.addTrait(
                    {
                      name: perName,
                      label: `Role #${index}`,
                      options,
                      type: 'role-trait',
                    },
                    { at: traitsSize },
                  );
                  traitsSize++;
                });

                if (roleItems && roleItems.length > roleKeys.length) {
                  this.addTrait(
                    {
                      name: `data-role-${roleKeys.length}`,
                      label: `Role #${roleKeys.length}`,
                      options,
                      type: 'role-trait',
                    },
                    { at: traitsSize },
                  );
                  traitsSize++;
                }
              } else {
                this.addTrait(
                  {
                    name: `data-role-0`,
                    label: 'Role #0',
                    options,
                    type: 'role-trait',
                  },
                  { at: traitsSize },
                );
              }
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.tagName === 'SELECT' && el.type === `${types.select}`) {
            console.log(`Checking div issue: i am ${types.select}`);
            return { type: `${types.select}` };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
};
